module.exports = ".cookie-warner {\n    background-color: #969696;\n    position: fixed;\n    z-index: 100;\n    bottom: 0px;\n    left: 0px;\n    right: 0px;\n}\n\n.cookie-warner-text {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    color: white;\n    font-family: 'Montserrat Regular';\n}\n\n.cookie-warner-ok {\n    padding-top: 10px;\n    padding-bottom: 10px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/cookie-warner/cookie-warner.component.css
// module id = ./src/app/cookie-warner/cookie-warner.component.css
// module chunks = main